<vs-dialog [config]="dialogConfig">
  <vs-dialog-header [config]="dialogHeaderConfig"></vs-dialog-header>

  <div class="p-6">
    <form class="w-[480px] max-w-full flex flex-col gap-5" [formGroup]="form">
      <vs-form-field appearance="horizontal" class="[&>div>div:first-child]:max-w-[96px]" [config]="{ label: 'Title' }">
        <vs-input-container>
          <input
            required
            type="text"
            minlength="1"
            formControlName="title"
            placeholder="Please write a title for your document"
          />
          <vs-badge *ngIf="fileExtension$ | async as ext" theme="info" slot="end">{{ ext }}</vs-badge>
        </vs-input-container>
      </vs-form-field>

      <vs-form-field
        appearance="horizontal"
        class="[&>div>div:first-child]:max-w-[96px] -mb-1.5"
        [config]="{ label: 'Description' }"
      >
        <textarea
          vsInput
          vsAutosize
          rows="2"
          minRows="2"
          maxRows="4"
          formControlName="description"
          placeholder="Please write a description (optional)"
        ></textarea>
      </vs-form-field>

      <vs-file-input
        *ngIf="!form.value.file"
        formControlName="file"
        moreInfo="Accepts all major file types"
        class="h-24 py-6"
      ></vs-file-input>

      <div *ngIf="form.value.file" vsInputBox class="h-24 px-6 py-4 flex items-center gap-6">
        <div class="h-full aspect-square rounded-md overflow-hidden border border-gray-300">
          <img
            *ngIf="imageResourceUrl$ | async as imageResourceUrl; else otherFileType"
            [src]="imageResourceUrl | safe: 'resourceUrl'"
            class="w-full h-full object-cover"
          />
          <ng-template #otherFileType>
            <div class="w-full h-full flex items-center justify-center">
              <vs-icon name="file-attachment-02" size="32" class="text-gray-600"></vs-icon>
            </div>
          </ng-template>
        </div>
        <div class="flex-1 overflow-hidden text-xs text-gray-600">{{ form.value.file.name }}</div>
        <button vs-icon-button appearance="outline" (click)="form.patchValue({ file: null })">
          <vs-icon name="trash-01"></vs-icon>
        </button>
      </div>
    </form>

    <div class="mt-8 grid grid-cols-[1fr_1fr] sm:grid-cols-[1fr_auto_auto] gap-3">
      <button
        *ngIf="(canCreateRuns$ | async) === true && hideUploadAndRunButton !== true"
        vs-button
        disabled
        appearance="outline"
        class="w-full sm:w-fit col-span-2 sm:col-span-1"
      >
        Upload + Run
      </button>

      <button vs-button appearance="outline" class="w-full sm:col-start-2" [disabled]="uploading" (click)="close()">
        Cancel
      </button>

      <button
        *ngIf="canUpload$ | async"
        vs-button
        theme="primary"
        class="w-full"
        [class.!opacity-100]="uploading"
        [disabled]="form.invalid || uploading"
        (click)="upload()"
      >
        <div class="flex items-center">
          <svg
            class="text-base h-4 transition-[width,margin] {{uploading ? 'animate-spin w-4 mr-2' : 'w-0 mr-0'}}"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path
              class="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            ></path>
          </svg>
          <div>Upload</div>
          <div class="transition-[width] overflow-hidden {{uploading ? 'w-6' : 'w-0'}}">ing</div>
        </div>
      </button>
    </div>
  </div>
</vs-dialog>
